module.exports = __webpack_public_path__ + "static/img/about_company_banner_tr.89e1dbc5.jpg";